import React, { FC, useMemo, useState } from 'react'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, MutationDefinition } from '@reduxjs/toolkit/dist/query'
import { MutationTrigger } from '@reduxjs/toolkit/dist/query/react/buildHooks'
import cn from 'classnames'
import { Button } from 'components/extend/Button'
import { ModalFooter } from 'components/extend/Modal'
import { FieldTextarea } from 'forms/FieldTextarea'
import { Form } from 'forms/Form'
import { required } from 'forms/validators'
import { useIsMobile } from 'hooks/media'
import { useActions } from 'hooks/useActions'
import { getFieldError } from 'modules/profile/helpers'

import s from './OrderCancelForm.module.less'

type TProps = {
  cancelOrder: MutationTrigger<
    MutationDefinition<any, BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>, never, any, 'api'>
  >
  id: string | undefined
  onClose: (() => void) | undefined
  isSubmitting?: boolean
  onConfirm?: () => void | Promise<any>
  refetch?: () => void
  refetchTable?: () => void
}

export const OrderCancelForm: FC<TProps> = ({ id, isSubmitting, onClose, refetch, cancelOrder }: TProps) => {
  const isMobile = useIsMobile()
  const { updateOrderList } = useActions()
  const [error, setError] = useState<{ path: string; title: string }[]>([])

  const handleSubmit = (payload: { reason: string }) => {
    setError([])

    cancelOrder &&
      cancelOrder({ id, reason: payload.reason })
        .unwrap()
        .then(() => {
          onClose && onClose()
          refetch && refetch()
          updateOrderList()
        })
        .catch((error) => {
          setError(error.data.message)
        })
  }

  const initialValues = useMemo(
    () => ({
      reason: ''
    }),
    []
  )

  return (
    <Form
      keepDirtyOnReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
      render={(form) => (
        <form onSubmit={form.handleSubmit}>
          <FieldTextarea
            className={s.noIcon}
            disabled={isSubmitting}
            error={!form.dirtyFieldsSinceLastSubmit.reason && !!getFieldError(error, 'reason')}
            minRows={7}
            name="reason"
            placeholder="Укажите причину"
            validate={required}
            errorLabel={
              !form.dirtyFieldsSinceLastSubmit.reason &&
              ((!form.values.reason.length ? 'Обязательное поле' : '') || getFieldError(error, 'reason'))
            }
          />
          <ModalFooter className={cn(s.modalFooter, s.modalFooterAddForm)}>
            {!isMobile && (
              <Button className={s.buttonCancel} loading={isSubmitting} onClick={onClose} size="lg">
                Отменить
              </Button>
            )}
            <Button appearance="primary" className={s.buttonAccept} loading={isSubmitting} size="lg" type="submit">
              Подтвердить
            </Button>
          </ModalFooter>
        </form>
      )}
    />
  )
}
